import React, { useState, useContext, useEffect } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { decodeToken } from "react-jwt";
import MessageDialog from "../components/MessageDialog";
import axios from "axios";
import GlobalContext from "../utils/GlobalContext";
import { Form, Input, Button, Typography, Select } from "antd";
import LoadingModal from "../utils/LoadingModal";

const { Title } = Typography;
const { Option } = Select;

const LoginButton = ({ onLogin, currentDomain, setCurrentDomain }) => {
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const globals = useContext(GlobalContext);

  const showErrorDialog = () => {
    setErrorDialogVisible(true);
  };

  const handleOkErrorDialog = () => {
    setErrorDialogVisible(false);
  };

  const handleDomainChange = (value) => {
    setCurrentDomain(value);
    //guardar dominio en localstorage
    localStorage.setItem('domainTempshow', value);
  };

  //al cargar la pagina, se verifica si hay un dominio guardado en localstorage
  useEffect(() => {
    const domainTempshow = localStorage.getItem('domainTempshow');
    if (domainTempshow) {
      setCurrentDomain(domainTempshow);
    }
    // eslint-disable-next-line
  }, []);


  const handleGoogleLogin = async (credentialResponse) => {
    setLoading(true);
    const info = decodeToken(credentialResponse.credential);
    const email = info.email;
    try {
      const res = await axios.post(
        `${globals.SERVICE_API_AUTH}/v1/login-google-v2`,
        { email: email }
      );
      const result = res.data;
      if (result.status === 0) {
        const res2 = await axios.post(
          `${globals.SERVICE_API_AUTH}/v1/verify-token`,
          { token: result.data.token }
        );
        const result2 = res2.data;
        if (result2.status === 0) {
          setLoading(false);
          const uid = result2.data.tokenDecoded.uid;
          localStorage.setItem('timestamp', new Date().getTime())
          onLogin({
            changePassTemp: uid.change_password,
            userEmail: uid.email,
            userRole: uid.role,
            type: uid.type,
            token: result.data.token
          });
        } else {
          setLoading(false);
          showErrorDialog();
          return;
        }
      } else {
        setLoading(false);
        showErrorDialog();
        return;
      }
    } catch (err) {
      setLoading(false);
      console.log("err", err)
      if (err?.response?.data === undefined) {
        setErrorMessage("Login failed");
      } else {
        setErrorMessage(err?.response?.data?.message);
      }
      showErrorDialog();
      return;
    }
  };

  const handleLogin = async (values) => {
    setLoading(true);
    values.username = values.username.trim();
    values.password = values.password.trim();
    try {
      const res = await axios.post(`${globals.SERVICE_API_AUTH}/v1/login`, {
        email: values.username,
        password: values.password,
      });
      const result = res.data;
      if (result.status === 0) {
        const res2 = await axios.post(
          `${globals.SERVICE_API_AUTH}/v1/verify-token`,
          { token: result.data.token }
        );
        const result2 = res2.data;
        if (result2.status === 0) {
          const uid = result2.data.tokenDecoded.uid;
          localStorage.setItem('timestamp', new Date().getTime())
          setLoading(false);
          onLogin({
            changePassTemp: uid.change_password,
            userEmail: uid.email,
            userRole: uid.role,
            type: uid.type,
            token: result.data.token,
            pass: values.password
          });
        } else {
          setLoading(false);
          showErrorDialog();
          return;
        }
      } else {
        setLoading(false);
        showErrorDialog();
        return;
      }
    } catch (err) {
      console.log("err", err.response)
      if (err?.response?.data === undefined) {
        setErrorMessage("Login failed");
      } else {
        setErrorMessage(err?.response?.data?.msg);
      }
      setLoading(false);
      showErrorDialog();
      return;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <LoadingModal open={loading} />
      <img src="/logo.png" height="200px" alt="" />
      <div>Versión {globals.VERSION}</div>
      <br />
      <div style={{ marginBottom: "20px", textAlign: "center" }}>
        <Title level={4}>Ingresar con Google</Title>
        <Select
          style={{ width: 250, marginBottom: '10px' }}
          placeholder="Seleccione un dominio"
          onChange={handleDomainChange}
          value={currentDomain}
        >
          <Option value="dominio1">*.epa.biz</Option>
          <Option value="dominio2">bamerica.us</Option>
          <Option value="dominio3">cuboconstruye.com</Option>
          <Option value="dominio3_1">selvacoral.com</Option>
          <Option value="dominio4">ologistics.com</Option>
        </Select>
        <div style={{ width: "250px", margin: "0 auto" }}>
          <GoogleLogin
            buttonText="Autenticarse con Google"
            onSuccess={handleGoogleLogin}
            onFailure={() => {
              console.log("Login failed");
            }}
            width={250}
          />
        </div>
      </div>
      <Title level={4}>Ingresar con usuario externo</Title>
      <div
        style={{
          width: "300px",
          padding: "20px",
          border: "1px solid #e0e0e0",
          borderRadius: "5px",
        }}
      >
        <Form
          name="loginForm"
          onFinish={handleLogin}
        >
          <Form.Item
            label="Usuario"
            name="username"
            rules={[
              { required: true, message: "Por favor ingrese su usuario" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Contraseña"
            name="password"
            rules={[
              {
                required: true,
                message: "Por favor ingrese su contraseña",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
              Ingresar
            </Button>
          </Form.Item>
        </Form>
        {/* <div style={{ textAlign: 'center' }}>
          <Text type="secondary">
            Forgot password?
          </Text>
        </div> */}
      </div>
      
      <MessageDialog
        visible={errorDialogVisible}
        title="Login - Permiso denegado"
        message={`${errorMessage}, Por favor intente de nuevo. Si el problema persiste, contacte al administrador.`}
        onOk={handleOkErrorDialog}
        onCancel={handleOkErrorDialog}
        confirm={false}
      />
    </div>
  );
};

export default LoginButton;
